import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import Index from './Index';
import Reports from './components/Reports/Reports';
import SelfAssign from './components/SelfAssign';
import AssignmentResults from './components/AssignmentResults/AssignmentResults';
import UploadOfflineAnswers from './components/UploadOfflineAnswers';
import AssignToStudents from './components/AssignToStudents/AssignToStudents';
import MCAnswerBreakdownReport from './components/Reports/MCAnswerBreakdownReport';
import AssignmentCumulativeReport from './components/Reports/AssignmentCumulativeReport';
import ScoreReport from './components/Reports/ScoreReport';
import AssignmentChanges from '../MoreActions/components/AssignmentChanges';
import VocabularyStudySheet from './components/Reports/VocabularyStudySheet';
import TimeOnTaskReport from './components/Reports/TimeOnTaskReport';
import ComprehensiveReport from './components/Reports/ComprehensiveReport';
import StudentRetakeReport from './components/Reports/StudentRetakeReport';
import ClassRetakeReport from './components/Reports/ClassRetakeReport';
import StudentSessionReportNew from './components/Reports/StudentSessionReport';
import StudentSessionReport from './components/StudentSessionReport/Index';

const Main = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Index />}>
          <Route index element={<Navigate to="assignment_result" />} />
          <Route path="assignment_result" element={<AssignmentResults />} />
          <Route path="reports" element={<Reports />} />
          <Route path="self_assign" element={<SelfAssign />} />
          <Route path="upload_offline_answers" element={<UploadOfflineAnswers />} />
          <Route path="assign_to_students" element={<AssignToStudents />} />
        </Route>
        <Route path="reports/mc_answer_breakdown_report" element={<MCAnswerBreakdownReport />} />
        <Route path="reports/class_cumulative_report" element={<AssignmentCumulativeReport />} />
        <Route path="reports/scores_report" element={<ScoreReport />} />
        <Route path="reports/assignment_changes_report" element={<AssignmentChanges />} />
        <Route path="reports/vocabulary_study_sheet" element={<VocabularyStudySheet />} />
        <Route path="reports/timeOnTaskReport" element={<TimeOnTaskReport />} />
        <Route path="reports/assignment_comprehensive_report" element={ <ComprehensiveReport/>} />
        <Route path="reports/class_retake_report" element={<ClassRetakeReport />} />
        <Route path="reports/student_retake_report" element={<StudentRetakeReport />} />
        <Route path="reports/student_session_report" element={<StudentSessionReportNew />} />
        <Route path="reports/student_session_report/:assignmentId/:studentId/:incompleteScoring" element={<StudentSessionReport />} />
      </Routes>
    </div>
  );
};

export default Main;
